import { useState } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router";
import { Footer } from "../components/Footer";
import { useAuth } from "../context/auth";

export function AcceptTermsPage() {
	const { workspaceSlug } = useParams<{ workspaceSlug: string }>();
	const { checkSession } = useAuth();
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const [submitting, setSubmitting] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const returnTo = searchParams.get("returnTo") || `/${workspaceSlug}/`;

	async function handleAccept() {
		setSubmitting(true);
		setError(null);
		try {
			const res = await fetch(`/api/tenant/${workspaceSlug}/accept-tos`, {
				method: "POST",
				credentials: "include",
				headers: { "Content-Type": "application/json" },
			});
			if (!res.ok) {
				setError("Failed to accept terms. Please try again.");
				return;
			}
			await checkSession();
			navigate(returnTo, { replace: true });
		} catch {
			setError("Network error. Please try again.");
		} finally {
			setSubmitting(false);
		}
	}

	return (
		<div className="min-h-screen flex flex-col bg-gray-50">
			<div className="flex-1 flex items-center justify-center">
				<div className="max-w-sm w-full p-6 bg-white rounded-lg shadow">
					<h1 className="text-xl font-semibold mb-4">
						Updated Terms of Service
					</h1>
					<p className="text-sm text-gray-600 mb-6">
						We've updated our Terms of Service. Please review and accept them to
						continue using the application.
					</p>
					<p className="text-sm mb-6">
						<Link
							to="/terms"
							target="_blank"
							rel="noopener noreferrer"
							className="text-blue-600 hover:underline"
						>
							Read the Terms of Service
						</Link>
					</p>
					{error && <p className="text-sm text-red-600 mb-4">{error}</p>}
					<button
						type="button"
						onClick={handleAccept}
						disabled={submitting}
						className="w-full bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 disabled:opacity-50"
					>
						{submitting ? "Accepting..." : "I accept"}
					</button>
				</div>
			</div>
			<Footer />
		</div>
	);
}
